import React, { useEffect, useImperativeHandle, forwardRef } from 'react';
import { colors } from '@styles/colors';
import PaymentIcon from '@mui/icons-material/Payment';
import { BOLD_REDIRECT_URL, BOLD_DEFAULT_API_KEY } from '@utils/const';

const BotonBold = forwardRef(({ 
    integritySignature, 
    onClick, 
    apiKey, 
    orderId, 
    amount, 
    description,
    disabled = false,
    ancho = "26.5vh",
    redirectionUrl = BOLD_REDIRECT_URL,
}, ref) => {

  useEffect(() => {
    // Cargar el script de Bold si no existe
    if (!document.querySelector('script[src="https://checkout.bold.co/library/boldPaymentButton.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://checkout.bold.co/library/boldPaymentButton.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  useImperativeHandle(ref, () => ({
    openCheckout: () => {
      if (window.BoldCheckout) {
        const checkout = new window.BoldCheckout({
          orderId: orderId,
          currency: 'COP',
          amount: amount,
          apiKey: apiKey || BOLD_DEFAULT_API_KEY,
          integritySignature: integritySignature,
          description: description || 'Pago a traves de Embedded Checkout',
          tax: "vat-19", // Añadido basado en configuración previa
          redirectionUrl,
        });
        checkout.open();
      } else {
        console.error("Bold script not loaded yet");
      }
    }
  }));

  return (
    <div 
      onClick={() => {
        if (integritySignature && !disabled) {
          onClick();
        }
      }}
      style={{
        width: ancho,
        height: "6.5vh",
        boxSizing: 'border-box',
        backgroundColor: (!integritySignature || disabled) ? colors.gray400 : colors.verdeClaro,
        borderRadius: '2.8vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.9vh',
        fontFamily: 'Inter',
        color: colors.primaryText,
        cursor: (!integritySignature || disabled) ? 'not-allowed' : 'pointer',
        transition: 'all 0.3s ease',
        position: 'relative',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
        gap: '1vh',
        zIndex: 1,
        opacity: disabled ? 0.6 : 1
      }}>
        <span style={{ fontWeight: 600 }}>Pagar con Bold</span>
        <PaymentIcon sx={{ fontSize: '2.5vh' }} />
    </div>
  );
});

export default BotonBold;
